import {
  createAsyncThunk,
} from '@reduxjs/toolkit';

import type { ThunkApiType } from '@/store';
import type { TemperatureJson } from '@/types/domain/temperature/entities/temperatureEntity';

import { temperatureSlice } from '@/domain/temperature/redux';
import { service } from '@/share';

export const refreshTemperatureList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'temperature/refreshTemperatureList',
  async (_, thunkApi) => {
    const result: {
      items: TemperatureJson[],
      nextToken: string,
    } = await service.temperature.getTemperatureList(null);
    thunkApi.dispatch(temperatureSlice.actions.setTemperatureList(result));
  },
);

export const getTemperatureList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'temperature/getTemperatureList',
  async (_, thunkApi) => {
    const { nextToken, temperatureList } = thunkApi.getState().temperature;
    if (!nextToken) {
      if (temperatureList.length === 0) {
        thunkApi.dispatch(refreshTemperatureList());
      }
      return;
    }
    const result: {
      items: TemperatureJson[],
      nextToken: string,
    } = await service.temperature.getTemperatureList(nextToken);
    const newList = temperatureList.map((v) => v);
    for (let i = 0; i < result.items.length; i += 1) {
      newList.push(result.items[i]);
    }
    thunkApi.dispatch(temperatureSlice.actions.setTemperatureList({
      /** データ */
      items: newList,
      /** 次のトークン */
      nextToken: result.nextToken,
    }));
  },
);

export const createTemperature = createAsyncThunk<
  void,
  {
    /** データ */
    data: TemperatureJson,
    /** 施設IDリスト */
    facilityIds: string[],
  },
  ThunkApiType
>(
  'temperature/create',
  async (input, _thunkApi) => {
    await service.temperature.createTemperature(input.data);
    if (input.facilityIds.length > 0) {
      const promises = input.facilityIds.map(
        (v) => service.temperatureNursery.sendNurseryTemperature({
          data: input.data.data,
          pub: {
            sendId: input.data.pub.sendId,
            replyId: v,
            data: { ...input.data.pub.data },
          },
        }),
      );
      await Promise.all(promises);
    }
  },
);

export const deleteTemperature = createAsyncThunk<
  void,
  {
    /** データ */
    data: TemperatureJson,
    /** 施設IDリスト */
    facilityIds: string[],
  },
  ThunkApiType
>(
  'temperature/delete',
  async (input, _thunkApi) => {
    await service.temperature.deleteTemperature(input.data);
    if (input.facilityIds.length > 0) {
      const promises = input.facilityIds.map(
        (v) => service.temperatureNursery.removeNurseryTemperature({
          data: input.data.data,
          pub: {
            sendId: input.data.pub.sendId,
            replyId: v,
            data: { ...input.data.pub.data },
          },
        }),
      );
      await Promise.all(promises);
    }
  },
);
